import * as React from 'react';
import { Component, Fragment } from 'react';
import styled from 'styled-components';
import { color, space, fontSize, breakpoint, borderRadius } from '@core-ds/primitives';
import { Search } from '@core-ds/icons/16';

declare global {
   interface Window {
      shared_constants: Record<string, any>;
   }
}

const SearchHotkey = styled.div`
   position: relative;
   right: ${space[4]};
   pointer-events: none;
   color: ${color.gray5};
   font-size: ${fontSize[0]};
   background-color: rgba(57, 68, 77, 0.5);
   border-radius: ${borderRadius.md};
   width: 20px;
   height: 20px;
   line-height: 20px;
   text-align: center;
`;

const Form = styled.form`
   position: relative;
   display: flex;
   align-items: center;
   height: 40px;
   flex-grow: 1;
   min-width: 100px;
   margin: 0;
   border-radius: ${borderRadius.pill};
   background: ${color.gray8};
   overflow: hidden;
   transition: background 0.1s;

   @media (min-width: ${breakpoint.xl}) {
      margin: 0 ${space[6]};
   }

   :focus-within {
      background: ${color.gray7};
   }

   :focus-within ${SearchHotkey} {
      color: ${color.gray7};
   }
`;

const TextBox = styled.input.attrs({ type: 'text' })`
   height: 100%;
   appearance: none;
   box-sizing: border-box;
   flex: 1;
   outline: none;
   border: none;
   background: transparent;
   color: ${color.white};
   font-size: ${fontSize[1]};
   padding: ${space[1]} ${space[6]} ${space[1]} ${space[7]};

   ::placeholder {
      color: ${color.gray4};
   }
`;

const IconContainer = styled.div`
   position: absolute;
   display: flex;
   align-items: center;
   top: 0;
   bottom: 0;
   left: ${space[4]};
   pointer-events: none;
`;

const SearchBar = props => {
   const placeholder = props.isOnCart ? _js('Search by device or model #') : _js('Search');

   return (
      <Form action={window.shared_constants.GuideURI('TAG_SEARCH')} method="get">
         <IconContainer>
            <Search color={color.gray3} focusable="false" />
         </IconContainer>
         <TextBox
            name="query"
            aria-label="search"
            id={props.isMobile ? 'mobileSearchForm' : 'searchForm'}
            spellCheck="false"
            autoComplete="off"
            size="1"
            placeholder={placeholder}
            tabIndex={props.tabbable ? 0 : -1}
         />
         {!props.isMobile && <SearchHotkey>/</SearchHotkey>}
         {props.isOnCart && (
            <Fragment>
               <input type="hidden" name="doctype" value="product" />
               <input type="hidden" name="search-store" value="1" />
            </Fragment>
         )}
      </Form>
   );
};

SearchBar.defaultProps = {
   tabbable: true,
};

export default SearchBar;
